import { HStack, Span, VStack } from "@bpba/ui-components";
import styled from "styled-components";
import { color, ColorProps, border, BorderProps } from "styled-system";
import DOMPurify from "dompurify";
 
type InfoItemProps = {
  index: number;
  titulo: string;
  info: string[];
};
 
export const InfoItem = (props: InfoItemProps) => {
  if (!props) return <></>;
 
  return (
    <HStack py={"20px"}>
      <StyledIndexContainer border="2px solid" borderColor="primary.0">
        <StyledIndex color="primary.0">{props.index}</StyledIndex>
      </StyledIndexContainer>
      <StyledContainer
        ml={3}
        pl={3}
        borderLeft="4px solid"
        borderLeftColor="primary.0"
      >
        <StyledTitle color="primary.0" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(props.titulo)}} tabIndex={0}></StyledTitle>
        {props.info.map((item, index) => {
          return (
            <Span mt={2} key={index} dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item)}} tabIndex={0}>
               
            </Span>
          );
        })}
      </StyledContainer>
    </HStack>
  );
};
 
const StyledContainer = styled(VStack)<BorderProps>(border);
 
const StyledIndexContainer = styled.div<BorderProps>(border, {
  fontSize: "20px",
  borderRadius: "20px",
  height: "35px",
  width: "37px",
  textAlign: "center",
});
 
const StyledIndex = styled.span<ColorProps>(color, {
  verticalAlign: "sub",
});
 
const StyledTitle = styled.span<ColorProps>(color, {
  fontSize: "18px",
  lineHeight: "20px",
});